// Axios and configuration
import Axios from "axios";
// Interfaces
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import AxiosConfig from "src/utilities/AxiosConfig";
// Utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Send a cancellation request to the API.
 *
 * @param approvalInstanceId - approvalInstanceId that is being cancelled
 * @returns A boolean indicating whether the request was successful
 */

const CancelLeaseRequest = async (
	approvalInstanceId: number,
): Promise<boolean> => {
	try {
		const response = await Axios.post<I_BaseAPIResponse<string>>(
			`${process.env.REACT_APP_API_URL}/api/approval/lease/cancel/${approvalInstanceId}`,
			null,
			AxiosConfig.configValue("min"), // "min" config may indicate lighter headers or minimal auth
		);

		if (response.data.HasError) {
			snackBar({
				type: "error",
				text: response.data.ErrorMessage,
				timeout: 4000,
			});
			return false;
		}

		return true;
	} catch (error) {
		console.error("CancelAction failed:", error);
		snackBar({
			type: "error",
			text: "Failed to cancel request",
			timeout: 4000,
		});
		return false;
	}
};

export default CancelLeaseRequest;
